import React from 'react'
import { BulkDeleteWithConfirmButton, Datagrid, ListProps } from 'react-admin'
import { KExporter } from 'services/csv/exporter'
import { useKResource } from 'services/hooks/useKResource'
import ReorderableList from 'ui-shared/DraggableList/ReorderableList'
import KFilters from 'ui-shared/KFilters'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'

export type BaseListProps = Omit<
  ListProps,
  'title' | 'exporter' | 'resource' | 'children'
> & {
  exporter?: KExporter | false
  children?: React.ReactNode
}

export type CatalogItemBaseListProps = BaseListProps

const CatalogItemBaseList: React.FC<CatalogItemBaseListProps> = ({
  children,
  exporter = false,
  pagination = false as false,
  bulkActionButtons = <BulkDeleteWithConfirmButton mutationMode="optimistic" />,
  filters,
  ...rest
}) => {
  const resource = useKResource()

  return (
    <SectionWrapper title={`resources.${resource}.name`}>
      <ReorderableList
        {...rest}
        exporter={exporter}
        pagination={pagination}
        filters={filters ?? <KFilters />}
      >
        <Datagrid rowClick="edit" bulkActionButtons={bulkActionButtons}>
          <LocalizedTextField source="name" sortable={false} />
          {children}
        </Datagrid>
      </ReorderableList>
    </SectionWrapper>
  )
}

export default CatalogItemBaseList
